import { CompanyName } from 'modules/utils/ConfigUtils';

export const translations = {
  en: {
    status_title: 'Your COVID-19 test has been ordered.',
    paragraph: `Please click on the link below to review a list of ${CompanyName} facilities where you can pick up your saliva (drool) kit and drop off your saliva (drool) sample. Proceed to any site to take the test.`,
    link: `${CompanyName} COVID-19 testing facilities`,
    site_take_test: 'Proceed to any site to take the test.',
    email_send: 'A summary of this information will',
    email_send_2: ' be sent to ',
    email_send_3: ' shortly.',
    another_test: 'Order another Covid-19 test',
    create_account: 'Creating an account gives you these additional benefits',
    personalized_care: 'Personalized Care',
    health_info: 'See all your health info at a glance',
    notifications: 'Notifications',
    receive_alerts:
      'Receive alerts about new medical info available, new messages from your provider, and more.',
    access_doctors: 'Access to your doctors',
    connect_providers: 'Connect with your past providers.',
    create_account_button: 'Create MyHealth + account'
  },
  es: {
    status_title: 'Se ha ordenado su prueba de COVID-19.',
    paragraph: `Haga clic en el siguiente enlace para revisar una lista de instalaciones de ${CompanyName} donde puede recoger su kit de saliva y entregar su muestra de saliva. Diríjase a cualquier sitio para realizar la prueba.`,
    link: `Centros de pruebas COVID-19 de ${CompanyName}`,
    site_take_test: 'Proceda a cualquier sitio para hacer la prueba.',
    email_send: 'En breve enviaremos un resumen de esta información a',
    email_send_2: '',
    email_send_3: '',
    another_test: 'Pida otra prueba de Covid-19',
    create_account: 'La creación de una cuenta le proporciona estas ventajas adicionales',
    personalized_care: 'Atención personalizada',
    health_info: 'Ver toda su información de salud de un vistazo',
    notifications: 'Notificaciones',
    receive_alerts:
      'Recibir alertas sobre nueva información médica disponible, nuevos mensajes de su proveedor y más.',
    access_doctors: 'Acceso a sus médicos',
    connect_providers: 'Conectar con sus proveedores anteriores y preferidos.',
    create_account_button: 'Crear una cuenta MyHealth +'
  }
};
